import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { api, API } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { inr } from "./ReimbParts";

const KINDS = [["employee", "Employee-wise"], ["department", "Department-wise"], ["category", "Category-wise"], ["monthly", "Monthly"],
  ["pending_approval", "Pending Approval"], ["pending_payment", "Pending Payment"], ["paid", "Paid"], ["rejected", "Rejected / Returned"], ["ageing", "Ageing"]];
const MONEY = new Set(["total_claim", "net_payable", "paid", "outstanding", "amount", "advance"]);

export function ReimbReports() {
  const [kind, setKind] = useState("employee");
  const [frm, setFrm] = useState("");
  const [to, setTo] = useState("");
  const [rows, setRows] = useState([]);
  const qs = `frm=${frm}&to=${to}&scope=all`;

  useEffect(() => { api.get(`/reimbursements/reports/${kind}?${qs}`).then((r) => setRows(r.data.rows)).catch(() => setRows([])); }, [kind, qs]);

  const cols = rows[0] ? Object.keys(rows[0]) : [];
  return (
    <div className="space-y-3" data-testid="reimb-reports">
      <div className="flex flex-wrap gap-1">
        {KINDS.map(([k, l]) => (
          <button key={k} onClick={() => setKind(k)} data-testid={`report-kind-${k}`}
            className={`text-[10px] font-mono uppercase tracking-widest px-2.5 py-1.5 rounded border transition-colors ${kind === k ? "bg-primary/15 text-primary border-primary/40" : "border-border text-muted-foreground hover:text-foreground"}`}>{l}</button>))}
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <Input type="date" value={frm} onChange={(e) => setFrm(e.target.value)} className="w-40 h-9" data-testid="report-from" />
        <span className="text-xs text-muted-foreground">to</span>
        <Input type="date" value={to} onChange={(e) => setTo(e.target.value)} className="w-40 h-9" data-testid="report-to" />
        <span className="text-xs text-muted-foreground ml-2">{rows.length} row(s)</span>
        <div className="ml-auto flex gap-2">
          <Button size="sm" variant="outline" asChild><a href={`${API}/reimbursements/reports/${kind}?${qs}&fmt=xlsx`} data-testid="report-export-xlsx"><Download className="w-3.5 h-3.5 mr-1" /> Excel</a></Button>
          <Button size="sm" variant="outline" asChild><a href={`${API}/reimbursements/reports/${kind}?${qs}&fmt=pdf`} data-testid="report-export-pdf"><Download className="w-3.5 h-3.5 mr-1" /> PDF</a></Button>
        </div>
      </div>
      <div className="bg-card border border-border rounded-lg overflow-x-auto">
        <table className="w-full text-sm" data-testid="report-table">
          <thead><tr className="border-b border-border text-left">
            {cols.map((c) => <th key={c} className="px-3 py-2.5 text-[10px] font-mono uppercase tracking-widest text-muted-foreground whitespace-nowrap">{c.replace(/_/g, " ")}</th>)}
          </tr></thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={r.claim_id || r.employee || r.department || r.category || r.month || i} className="border-b border-border/50">
                {cols.map((c) => <td key={c} className={`px-3 py-2 text-xs ${MONEY.has(c) ? "metric" : ""}`}>{MONEY.has(c) ? inr(r[c]) : String(r[c] ?? "—").replace(/_/g, " ")}</td>)}
              </tr>))}
            {rows.length === 0 && <tr><td className="px-4 py-8 text-center text-sm text-muted-foreground">No data for this report / range.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
